import { getPriceString } from "../../utils/getPriceString";

const RecapCard = ({ photo, title, summary, price, priceNote, bundleSelected, setRequestData, setPeopleData }) => {
    const handleClick = (id, peopleNumber) => {
        let bundleId;
        if (id === bundleSelected) {
            bundleId = null
        } else {
            bundleId = id
        }
        setRequestData(prevState => ({
            ...prevState,
            bundleId
        }))
        // Restituisco a SendRequest (parent) l'inizializzazione dei dati dei partecipanti
        let peopleDataFields = {};
        const fixedPeopleNubmer = peopleNumber === 0 ? 1 : peopleNumber;
        for (let i = 0; i < fixedPeopleNubmer; i++) {
            peopleDataFields[`user-${i}`] = {
                name: '',
                surname: '',
                birthdate: ''
            }
        };
        setPeopleData({ amount: fixedPeopleNubmer, data: peopleDataFields });
    }

    return (
        <div className="w-full flex flex-col gap-8 items-center">
            <div className="flex flex-col md:flex-row gap-4 items-center w-full p-8 rounded-xl bg-white">
                {/* LEFT */}
                <div className="w-full md:w-[300px] h-[300px] border overflow-hidden rounded-xl">
                    <img src={photo} alt={title} className="h-full w-full object-cover" />
                </div>

                {/* RIGHT */}
                <div className="flex-grow border rounded-xl p-4">
                    <h2>{title}</h2>
                    <p>{summary}</p>
                    {price && price.length && <h3 className="mt-16">Seleziona il pacchetto:</h3>}
                    <div className="flex flex-col gap-2">
                        {
                            price && price.length > 0 && price.map((element) => {
                                return <button key={element._id} id={element._id} className={`border-2 ${element._id === bundleSelected && 'border-[#225424]'} p-2 rounded text-start hover:bg-neutral-100`} onClick={() => handleClick(element._id, element.people)}>{getPriceString(element.value, element.people)} </button>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>

    )
}

export default RecapCard